import { useInView } from '../../../hooks/useInView';

export default function Values() {
  const { ref, inView } = useInView(0.1);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/values.jpg"
          alt="Farm at sunrise background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#FAF8F5]/90" />
      </div>

      <div
        ref={ref}
        className={`relative z-10 flex flex-col items-center justify-center text-center px-8 py-24 w-full transition-all duration-1000 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#2C4A3B]/12 mb-8">
          <i className="ri-bible-line text-[#2C4A3B] text-3xl" />
        </div>

        <p className="text-[#C8973A] text-sm uppercase tracking-[0.3em] mb-5 font-semibold">
          Our Foundation
        </p>

        <h2 className="font-serif text-3xl md:text-5xl text-[#3A2A1A] font-bold max-w-3xl leading-tight mb-5">
          &ldquo;Trust in the Lord with all your heart and lean not on your own understanding.&rdquo;
        </h2>

        <p className="text-[#8B7355] font-semibold text-sm tracking-wider mb-10">
          Proverbs 3:5
        </p>

        <div className="w-16 h-px bg-[#C8973A] mb-10" />

        <p
          className="text-[#5C3D2E] text-base max-w-xl leading-relaxed mb-4"
          style={{ fontFamily: "'Nunito', sans-serif" }}
        >
          At Mastro Family Farm, our Christian faith is not just a backdrop it is the very soil in
          which everything we do is rooted. We wake up each morning grateful for the land, the rain, the sun,
          and the opportunity to tend God&apos;s creation.
        </p>
        <p
          className="text-[#5C3D2E] text-base max-w-xl leading-relaxed mb-10"
          style={{ fontFamily: "'Nunito', sans-serif" }}
        >
          We believe in simplicity, hard work, honest living, and above all love for God, family, and
          neighbor. This farm is our ministry. Every harvest, a blessing.
        </p>

        <div className="flex flex-wrap justify-center gap-6 mb-10">
          {[
            { icon: 'ri-heart-3-fill', label: 'Christian Values' },
            { icon: 'ri-seedling-fill', label: 'Small Family Farm' },
            { icon: 'ri-group-2-fill', label: 'Community Focused' },
          ].map(({ icon, label }) => (
            <div key={label} className="flex items-center gap-2 bg-[#2C4A3B]/8 px-5 py-2.5 rounded-full">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${icon} text-[#2C4A3B] text-base`} />
              </div>
              <span className="text-[#3A2A1A] text-sm font-medium">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
